import React, { useState, useEffect } from "react";
import axios from "axios";
import Completed from "../../../../../assets/images/rightSign.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const LearningSessionCompleted = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/learning_session/completed`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Completed Live Chat Events"
        image={Completed}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/learning-session/details`}
        />
      )}
    </>
  );
};

export default LearningSessionCompleted;
